import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aq-onesix-oneseven',
  templateUrl: './aq-onesix-oneseven.component.html',
  styleUrls: ['./aq-onesix-oneseven.component.scss']
})
export class AqOnesixOnesevenComponent implements OnInit {
  src: string ='/assets/pdf/NAAC_2016-17.pdf';
  constructor() { }

  ngOnInit(): void {
  }

}
